export default __webpack_public_path__ + "static/media/480_business02-nl-mobile.2482b923.png";